var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/render-promo-entry.j2"] = require( "macros/render-promo-entry.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/footer/tertiary-content.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"tertiaryFooterPromo")) {
output += "\n    ";
env.getTemplate("macros/render-promo-entry.j2", false, "core/templates/footer/tertiary-content.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderPromo")) {
var t_4 = t_1.renderPromo;
} else {
cb(new Error("cannot import 'renderPromo'")); return;
}
context.setVariable("renderPromo", t_4);
output += "\n    ";
env.getTemplate("macros/urls.j2", false, "core/templates/footer/tertiary-content.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("contentfulUrl")) {
var t_8 = t_5.contentfulUrl;
} else {
cb(new Error("cannot import 'contentfulUrl'")); return;
}
context.setVariable("contentfulUrl", t_8);
output += "\n\n    ";
var t_9;
t_9 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"tertiaryFooterPromo");
frame.set("promo", t_9, true);
if(frame.topLevel) {
context.setVariable("promo", t_9);
}
if(frame.topLevel) {
context.addExport("promo", t_9);
}
output += "\n    ";
var t_10;
t_10 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"default_image_quality");
frame.set("imageQuality", t_10, true);
if(frame.topLevel) {
context.setVariable("imageQuality", t_10);
}
if(frame.topLevel) {
context.addExport("imageQuality", t_10);
}
output += "\n    ";
var t_11;
t_11 = (lineno = 6, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["promo.linkAltText",""]));
frame.set("linkAltTextSafe", t_11, true);
if(frame.topLevel) {
context.setVariable("linkAltTextSafe", t_11);
}
if(frame.topLevel) {
context.addExport("linkAltTextSafe", t_11);
}
output += "\n\n    <div class=\"c-footer-promo__simple-banner dom-tertiary-footer-promo\" data-qa-tertiary-footer-promo>\n\n        <a ";
output += runtime.suppressValue((lineno = 10, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["marketing","footer_small",runtime.contextOrFrameLookup(context, frame, "linkAltTextSafe")])), env.opts.autoescape);
output += " href=\"";
output += runtime.suppressValue((lineno = 10, colno = 82, runtime.callWrap(t_8, "contentfulUrl", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"url")])), env.opts.autoescape);
output += "\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"externalLink")) {
output += " target=\"_blank\" rel=\"noopener noreferrer\" ";
;
}
output += ">\n\n            <picture>\n\n                <source media=\"medium\" data-srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"alternateBannerImage"), env.opts.autoescape);
output += "\" />\n\n                <img\n                        class=\"c-footer-promo__image lazyload\"\n                        alt=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "linkAltTextSafe"), env.opts.autoescape);
output += "\"\n                        src=\"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==\"\n                        data-srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "promo")),"bannerImage"), env.opts.autoescape);
if(runtime.contextOrFrameLookup(context, frame, "imageQuality")) {
output += "?q=";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "imageQuality"), env.opts.autoescape);
;
}
output += "\" />\n\n            </picture>\n\n        </a>\n\n    </div>\n";
})})})});
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/footer/tertiary-content.j2"] , dependencies)